var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "project-card",
    class: {
      'inactive': _vm.isInactive
    },
    on: {
      "click": function click($event) {
        return _vm.project.goTo('cabinet');
      }
    }
  }, [_c('div', {
    staticClass: "project-main"
  }, [_c('div', {
    staticClass: "project-logo"
  }, [_c('project-logo', {
    attrs: {
      "project": _vm.project,
      "size": "lg"
    }
  })], 1), _c('div', {
    staticClass: "project-name",
    attrs: {
      "title": _vm.project.name
    }
  }, [_vm._v(_vm._s(_vm.project.name))]), _c('a', {
    staticClass: "project-link",
    attrs: {
      "href": _vm.project.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.formattedLink))])]), _c('div', {
    staticClass: "project-info"
  }, [_c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('common.balance')))]), _c('span', [_vm._v(_vm._s(_vm.displayBalance))])]), _c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('average.check')))]), _c('span', [_vm._v(_vm._s(_vm.displayAvgAmount))])]), _c('div', {
    staticClass: "project-info-point"
  }, [_c('span', {
    staticClass: "project-info-name"
  }, [_vm._v(_vm._s(_vm.$t('payments.in.day')))]), _c('span', [_vm._v(_vm._s(_vm.project.paymentsPerDay))])])]), _c('div', {
    staticClass: "project-actions"
  }, [_c('div', {
    staticClass: "project-action",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.project.shownQrCode();
      }
    }
  }, [_c('span', {
    staticClass: "icon qr-code"
  })]), _c('div', {
    staticClass: "project-action",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onRouteToInvoicing($event);
      }
    }
  }, [_c('span', {
    staticClass: "icon plus"
  })]), _c('div', {
    staticClass: "project-action",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onRouteToPayout($event);
      }
    }
  }, [_c('span', {
    staticClass: "icon withdrawals"
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }